/* eslint-disable react/jsx-key */
/* eslint-disable react/jsx-indent */
import React, { useState, useMemo } from 'react'
import { Menu, Dropdown, message } from 'antd'
import SubMenu from 'antd/lib/menu/SubMenu'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import R from 'ramda'
import { connect } from 'react-redux'
import { getEventTypes, getUnits } from 'core'

// eslint-disable-next-line no-unused-vars
// const orderByGraphSequenceNum = (data, cardData) => {
//   const uniqData = R.uniqBy(
//     // R.props(['startDay', 'endDay', 'startPct', 'endPct']),
//     R.props(['startDay', 'endDay', 'endPct']),
//     data
//   ).map(d => ({
//     ...d,
//     startDay: d.startDay > 0 ? parseFloat(d.startDay || 0).toFixed(2) : 0,
//     endDay: d.endDay ? parseFloat(d.endDay || 0).toFixed(2) : 0,
//   }))

//   return R.sortBy(R.compose(R.prop('seqNo')))(uniqData || [])
// }

// eslint-disable-next-line no-unused-vars
export const orderByGraphSequenceNum = (data, cardData) => {
  const sd = R.sort(R.descend(R.prop('seqNo')))(data || [])
  const uniqData = R.uniqBy(
    R.props(['startDay', 'endDay', 'startPct', 'endPct']),
    // R.props(['startDay', 'endDay', 'endPct']),
    sd
  ).map(d => ({
    ...d,
    startDay: d.startDay > 0 ? parseFloat(d.startDay || 0).toFixed(2) : 0,
    endDay: d.endDay ? parseFloat(d.endDay || 0).toFixed(2) : 0,
  }))

  // return R.sort(R.ascend(R.prop('seqNo')))(uniqData || [])
  return R.sortWith([R.ascend(R.prop('seqNo')), R.descend(R.prop('eventNum'))])(
    uniqData
  )
}

const RectDataGroup = ({
  data,
  xScale,
  yScale,
  setMonthlyGraphRectSelection,
  margin,
  // eslint-disable-next-line no-unused-vars
  height,
  limit,
  days,
  setCardEditPromptRowData,
  setCardEditPrompt,
  setCardEditPromptMode,
  cardData,
  utility,
  unit,
  year,
  lock = 'U',
  actionPermits,
  eventTypes,
  units,
  isAdminTypeUser = false,
  ...props
}) => {
  const [eventNum, setEventNum] = useState(props.selectedEventNum)

  const isCOPUunit = !!(
    (units.find(u => u.unitId === unit || '') || {}).emsId === 'CO-PU'
  )

  const eventTypeMap = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(e => [e.eventType, e.description])
      )(eventTypes),
    [eventTypes]
  )

  const hasPermissionForCard97 = useMemo(
    _ => {
      const isCardAdmin97 = hasAccesPermits({
        authGodMode: false,
        actionPermits,
        eventActions: [ScreenPermissions.CARD97_ADMIN],
        matchAny: true,
      })

      if (!isCardAdmin97) return false

      //  if (eventNum === -1) return false

      if (isAdminTypeUser) return true

      if (lock === 'L') return false

      return true
    },
    [actionPermits, isAdminTypeUser, lock]
  )

  const eventId = eventTypes.map(e => e.eventType)
  const outageIds = [
    'SF',
    'SE',
    'U1',
    'U2',
    'U3',
    'MO',
    'PO',
    'PE',
    'ME',
    'IR',
    'MB',
    'RU',
  ]
  const derateIDs = ['D1', 'D2', 'D3', 'D4', 'PD', 'DE', 'DP', 'DM']

  return (
    <g>
      <Dropdown
        overlay={
          <Menu
            onClick={({ key }) => {
              // this.setState({ mode: key, promptNew: true })
              if (['E', 'V', 'D'].includes(key)) {
                if (eventNum === -1) {
                  message.warn('Please,Select Data')
                  return
                }
                setCardEditPromptMode(key)
                const d = cardData.find(
                  d => d.eventNum === eventNum && d.eventIdx === '1'
                )
                setCardEditPromptRowData({ ...d, unit: d.utility + d.unit })
                setCardEditPrompt(true)
              } else {
                const availCap = [
                  'SF',
                  'U1',
                  'U2',
                  'U3',
                  'MO',
                  'PO',
                  'SE',
                  'ME',
                  'PE',
                  'RS',
                  'IR',
                  'MB',
                  'RU',
                ].includes(key)
                  ? '0'
                  : undefined
                setCardEditPromptMode('N')
                setCardEditPromptRowData({
                  year,
                  utility,
                  unit,
                  eventType: key,
                  availCap,
                  eventNum: -1,
                  causeCode:
                    key === 'RS'
                      ? '0'
                      : key === 'CO'
                      ? '9340'
                      : key === 'PU'
                      ? '9345'
                      : undefined,
                  description: key === 'RS' ? 'Reserve Shutdown' : undefined,
                  conCode: '1',
                })
                setCardEditPrompt(true)
              }
            }}
          >
            <Menu.Item key="V" disabled={eventNum === -1}>
              View
            </Menu.Item>
            <Menu.Item
              key="E"
              disabled={!hasPermissionForCard97 || eventNum === -1}
            >
              Update
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item
              key="D"
              disabled={!hasPermissionForCard97 || eventNum === -1}
            >
              Delete
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="RS" disabled={!hasPermissionForCard97}>
              Add Reserve Shutdown
            </Menu.Item>
            <SubMenu
              title="Add Outage Event"
              disabled={!hasPermissionForCard97}
            >
              {outageIds
                .filter(o => eventId.includes(o))
                .map(o => (
                  <Menu.Item key={o}>
                    {o} - {eventTypeMap[o]}
                  </Menu.Item>
                ))}
            </SubMenu>
            <SubMenu
              title="Add Derate Event"
              disabled={!hasPermissionForCard97}
            >
              {derateIDs
                .filter(o => eventId.includes(o))
                .map(o => (
                  <Menu.Item key={o}>
                    {o} - {eventTypeMap[o]}
                  </Menu.Item>
                ))}
            </SubMenu>
            <Menu.Item key="NC" disabled={!hasPermissionForCard97}>
              Add Non-Curtailing Event
            </Menu.Item>
            {isCOPUunit && (
              <SubMenu
                title="Add CO/PU Event"
                disabled={!hasPermissionForCard97}
              >
                <Menu.Item key="CO">CO - Condensing</Menu.Item>
                <Menu.Item key="PU">PU - Pumping</Menu.Item>
              </SubMenu>
            )}
          </Menu>
        }
        trigger={['contextMenu']}
        // visible={this.state.visibleMenu || false}
      >
        <g>
          <rect
            x={xScale(0)}
            y={yScale(parseFloat(limit)) + margin}
            height={yScale(0) - yScale(limit)}
            width={xScale(parseFloat(days.toFixed(2))) - xScale(0)}
            style={{ fill: 'lawngreen' }}
            onContextMenu={_ => {
              setEventNum(-1)
            }}
          />
          {/* R.reverse(data).map */}
          {orderByGraphSequenceNum(data, cardData).map(d => (
            <rect
              // startday={d.startDay}
              // startPct={d.startPct}
              // endPct={d.endPct}
              // limit={limit}
              // margin={margin}
              // startendscal={xScale(d.endDay)}
              // endday={d.endDay}
              // endscal={yScale(limit)}
              x={xScale(parseFloat(d.startDay)) + xScale.bandwidth() / 2}
              y={yScale((limit * d.startPct) / 100) + margin}
              // height={
              //   height -
              //   yScale(
              //     d.endPct === 0
              //       ? limit
              //       : limit - parseFloat(((limit * d.endPct) / 100).toFixed(2))
              //   ) -
              //   margin
              // }
              height={
                yScale((limit * d.endPct) / 100) -
                yScale((limit * d.startPct) / 100)
              }
              width={
                xScale(parseFloat(d.endDay)) - xScale(parseFloat(d.startDay))
              }
              eventNum={d.eventNum}
              // eslint-disable-next-line no-unused-vars
              onClick={e => {
                setMonthlyGraphRectSelection({ eventNum: d.eventNum })
                setEventNum(d.eventNum + '')
                // setEventNum(e.target.getAttributeNS(null, 'eventNum'))
              }}
              style={{
                fill: `rgb(${d.red},${d.green},${d.blue})`,
                stroke: eventNum === d.eventNum ? 'black' : undefined,
              }}
              onContextMenu={e => {
                setEventNum(e.target.getAttributeNS(null, 'eventNum'))
                setMonthlyGraphRectSelection({ eventNum: d.eventNum })
              }}
            />
          ))}
        </g>
      </Dropdown>
    </g>
  )
}

const mapStateToProps = state => ({
  eventTypes: getEventTypes(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(RectDataGroup)
